import { useContext } from "react";
import { AuthContext } from "../components/context/authContext";

export default function useAuthContext() {
  return useContext(AuthContext)
}